import Link from "next/link"
import { NextSeo } from 'next-seo'
import { GetStaticProps } from 'next'
import AnalyticsTrigger from '../../components/atoms/AnalyticsTrigger'
import Layout from '../../components/templates/Layout'

const Courses = ({ courses }: {courses: [course:any]}) => {
  return (
    <Layout>
      <AnalyticsTrigger title={"コース一覧"} />
      <NextSeo
        title={"コース一覧 - デビクレ"}
      />
      <div>
        <div>
          <div style={{fontSize: "1.5rem",fontWeight: 700,color: "#8491a5", padding: "16px 0"}}>
            コース一覧
          </div>
          <div className="card-list" style={{display: "grid"}}>
            {courses.map((course, i) => {
              return (
                <Link href={"/courses/" + course.id} prefetch={false} key={i}>
                  <a className="card">
                    <span>{course.title}</span>
                  </a>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + 'courses/?pagination_count=100')
  const json = await res.json()
  const courses = await json.result
  return { props: { courses }, revalidate: 10}
}

export default Courses
